var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8573 15.5208C17.8573 16.9584 16.6921 18.1236 15.2545 18.1236C13.8169 18.1236 12.6517 16.9584 12.6517 15.5208C12.6517 14.0832 13.8169 12.918 15.2545 12.918C16.6921 12.918 17.8573 14.0832 17.8573 15.5208Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7235 8.52344H8.40994C8.19787 8.52344 8.02435 8.69695 8.02435 8.90901C8.02435 9.12108 8.19787 9.29459 8.40994 9.29459H10.7235C10.9355 9.29459 11.109 9.12108 11.109 8.90901C11.109 8.69695 10.9355 8.52344 10.7235 8.52344Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0774 9.0437H19.0334C18.6767 9.0437 18.3586 8.81234 18.2478 8.47494L18.0357 7.61215C17.9152 7.24582 17.5729 7 17.1922 7H13.3217C12.9361 7 12.5987 7.24582 12.4781 7.61215L12.2661 8.47494C12.1552 8.81234 11.8371 9.0437 11.4804 9.0437H7.43156C6.64107 9.0437 6 9.68477 6 10.4753V20.5684C6 21.3589 6.64107 22 7.43156 22H23.0774C23.8679 22 24.509 21.3589 24.509 20.5684V10.4753C24.509 9.68477 23.8679 9.0437 23.0774 9.0437ZM9.61504 11.5116C9.19087 11.5116 8.84383 11.1645 8.84383 10.7404C8.84383 10.3162 9.19087 9.96915 9.61504 9.96915C10.0392 9.96915 10.3862 10.3162 10.3862 10.7404C10.3862 11.1645 10.0392 11.5116 9.61504 11.5116ZM15.2545 19.6671C12.965 19.6671 11.1093 17.8114 11.1093 15.5219C11.1093 13.2323 12.965 11.3766 15.2545 11.3766C17.544 11.3766 19.3997 13.2323 19.3997 15.5219C19.3997 17.8114 17.544 19.6671 15.2545 19.6671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.ebe7291090c8c09d9dacbc715c8af062.svg";
export { ForwardRef as ReactComponent };